import { AssetAmount } from "@sundaeswap/asset";
import { ADA_METADATA } from "@sundaeswap/core";
import { UTxO } from "lucid-cardano";

import { TasteTest } from "../../../gql/generated/taste-test.sdk";

export const getLpTokenFromTasteTest = (tasteTest?: TasteTest, reservedUtxos?: UTxO[]) => {
  const { lpAssetNamePrefix } = window.__APP_CONFIG.SundaeSwap;
  if (!tasteTest || !reservedUtxos) return new AssetAmount(0, ADA_METADATA);

  const poolPolicyId = tasteTest.parameters.poolPolicyId;
  const lpAsset = reservedUtxos
    .map((utxo) =>
      Object.entries(utxo.assets).find(
        ([key, _]) => key.indexOf(`${poolPolicyId}${lpAssetNamePrefix}`) === 0
      )
    )
    .find((entry) => entry !== undefined);
  // If a matching asset is found, extract its value; otherwise, use 0n
  const amount = lpAsset ? lpAsset[1] : 0n;
  const assetId = lpAsset ? lpAsset[0].replace(poolPolicyId, `${poolPolicyId}.`) : "";

  return new AssetAmount(amount, { decimals: 0, assetId });
};
